import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { IDENTITY_VERIFICATION_COMPLETE } from '../constants/identityVerification';

export const useIdentityVerificationMessageListener = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type !== IDENTITY_VERIFICATION_COMPLETE) return;

      queryClient.invalidateQueries(['userIdentities']);
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [queryClient]);
};
